import { render, staticRenderFns } from "./AboutSampleBatch.vue?vue&type=template&id=3f732f60&scoped=true"
import script from "./AboutSampleBatch.vue?vue&type=script&lang=ts"
export * from "./AboutSampleBatch.vue?vue&type=script&lang=ts"
import style0 from "./AboutSampleBatch.vue?vue&type=style&index=0&id=3f732f60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f732f60",
  null
  
)

export default component.exports